import { ISODateTimeString, UUID } from '../../State/EvidenceDB/DatabaseTypes';
import { requireEvidenceDatabase } from '../../State/EvidenceDB/getDatabase';
import { ProcessInfo } from '../../State/ProcessInfo';
ProcessInfo.setProcess({processType: 'DevTools Root'});

/* IMPORTANT

	https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/API/devtools/network

	Like all the devtools APIs, this API is only available to code running in the document defined
	in the devtools_page manifest.json key, or in other devtools documents created by the extension
	(such as the panel's own document).
*/

export const tryGetApiGetHAR = () => {
	try {
		return chrome.devtools.network.getHAR;		
	} catch {
		console.error(`Attempt to access chrome.devtools.network.getHAR failed`);
		return undefined;
	}
}

export const tryGetHar = async () => {
	try {
		const getHAR = tryGetApiGetHAR();
		if (getHAR == null) return;
		ProcessInfo.log(`Attempting to get HAR`);
		const startMs = performance.now();
		const harLog = await new Promise<HARFormatLog>( (resolve, reject) => {
			getHAR( r => {
				if (r != null && typeof r == "object" && "entries" in r) {
					resolve(r as HARFormatLog);
				} else if (r == null) {
					reject(new Error("No har returned"));
				} else {
					reject(new Error("Bogus har returned", {cause: r}));
				}
			} );
		});
		if (harLog != null && "entries" in harLog) {
			ProcessInfo.log(`Got HAR with ${harLog.entries.length} entries in ${Math.floor(performance.now() - startMs)}ms`);
		}	else {
			ProcessInfo.log(`Got response from getHAR in ${Math.floor(performance.now() - startMs)}ms`, harLog);
		}
		return harLog;
	} catch (e) {
		ProcessInfo.errorLog(`Failure getting HAR`, e);
		return;
	}
}

export const tryGetAndSaveHar = async (recordingUuid: UUID) => {
	const dbPromise = requireEvidenceDatabase();
	const har = await tryGetHar();
	if (har == null) return false;
	const db = await dbPromise;
	await db.put("harLogs", {
		...har,
		whenRecordedIso: ISODateTimeString(),
		recordingUuid,
	});
	return true;
}

export const saveHarFromWithinPanel = tryGetAndSaveHar;
